import { IRequestOptions, IResponseResult } from 'models/api.model'
import { IConfigResponseRaw } from 'models/config.model'
import { APP_NAME, RequestMethod } from 'root-constants'
import { ApiService } from 'services/api.service'

export class ConfigApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getConfig(): Promise<IResponseResult<IConfigResponseRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
    }

    return this.api.makeRequest<IConfigResponseRaw>(
      `v1/flow/${APP_NAME}/config`,
      options,
    )
  }
}
